// extracted by mini-css-extract-plugin
export default {"btnPrimary":"Buttons_btnPrimary__keS7F","btnSecondary":"Buttons_btnSecondary__7dd06"};